module.exports = __webpack_public_path__ + "img/banner.e6fe0d94.png";